import { useEffect, useRef, useState } from "react";
import { API } from "@/lib/api";

const STALE_MS = 6000;

/**
 * Canlı spread SSE hook'u — /api/stream/spread.
 * EventSource header desteklemediği için JWT query param ile gider.
 * Dönen: { live, connected } — live: {darkex:{bid,ask,mid,age_ms},
 * binance:{...}, spread_pct, spread_abs, ts}
 */
export function useLiveSpread(symbol) {
  const [live, setLive] = useState(null);
  const [connected, setConnected] = useState(false);
  const lastMsgRef = useRef(0);

  useEffect(() => {
    const token = localStorage.getItem("darkex_jwt");
    if (!token || !symbol) return undefined;
    let es = null;
    let closed = false;
    let retryMs = 1500;
    let retryTimer = null;

    const connect = () => {
      if (closed) return;
      es = new EventSource(
        `${API}/stream/spread?symbol=${symbol}&token=${encodeURIComponent(token)}`
      );
      es.onopen = () => {
        retryMs = 1500;
        setConnected(true);
      };
      es.onmessage = (e) => {
        try {
          const d = JSON.parse(e.data);
          lastMsgRef.current = Date.now();
          if (!d.waiting) setLive(d);
        } catch {
          /* yoksay */
        }
      };
      es.onerror = () => {
        setConnected(false);
        es?.close();
        if (!closed) {
          retryTimer = setTimeout(connect, retryMs);
          retryMs = Math.min(retryMs * 2, 15000);
        }
      };
    };
    connect();

    // Bayatlık bekçisi: mesaj kesilirse "connected" söndür
    const staleTimer = setInterval(() => {
      if (lastMsgRef.current && Date.now() - lastMsgRef.current > STALE_MS) {
        setConnected(false);
      }
    }, 2000);

    return () => {
      closed = true;
      clearTimeout(retryTimer);
      clearInterval(staleTimer);
      es?.close();
      setConnected(false);
    };
  }, [symbol]);

  return { live, connected };
}
